import { Label as RadixLabel } from '@radix-ui/react-label'
import type { ComponentPropsWithoutRef } from 'react'

type LabelProps = ComponentPropsWithoutRef<typeof RadixLabel>

export const Label = (props: LabelProps) => {
  return <RadixLabel {...props} />
}
